export default "__VITE_ASSET__BkO7CIZK__"